import React from "react";
import { Box, Typography, Button, Divider } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const CartTotal = ({
  descuento,
  totalGeneral,
  totalFinal,
  descuentoAplicado,
  onNext,
  isDisabled,
  formatToCurrency,
  montoMinimo,
}) => {
  const montoInsuficiente = totalFinal < montoMinimo;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>

      {/* ── Avisos ── */}
      {(descuento || montoInsuficiente) && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
          {descuento && (
            <Box sx={{
              display: "flex", alignItems: "center", gap: 1,
              px: 1.5, py: 1,
              bgcolor: "var(--success-bg)", borderRadius: "var(--radius-sm)",
              border: "1px solid rgba(16,185,129,0.3)",
            }}>
              <CheckCircleOutlineIcon sx={{ fontSize: 15, color: "var(--success)", flexShrink: 0 }} />
              <Typography sx={{ fontSize: "0.78rem", color: "var(--success)", fontWeight: 500, fontFamily: "var(--font-body)" }}>
                Descuento aplicado por compra superior a {formatToCurrency(descuento.monto_minimo)}
              </Typography>
            </Box>
          )}
          {montoInsuficiente && (
            <Box sx={{
              display: "flex", alignItems: "center", gap: 1,
              px: 1.5, py: 1,
              bgcolor: "var(--danger-bg)", borderRadius: "var(--radius-sm)",
              border: "1px solid rgba(239,68,68,0.25)",
            }}>
              <WarningAmberRoundedIcon sx={{ fontSize: 15, color: "var(--danger)", flexShrink: 0 }} />
              <Typography sx={{ fontSize: "0.78rem", color: "var(--danger)", fontWeight: 500, fontFamily: "var(--font-body)" }}>
                El monto mínimo de compra es {formatToCurrency(montoMinimo)}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      <Divider sx={{ borderColor: "var(--divider)" }} />

      {/* ── Resumen ── */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>

        {descuento && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontSize: "0.82rem", color: "var(--text-muted)", fontFamily: "var(--font-body)" }}>
              Subtotal
            </Typography>
            <Typography sx={{ fontSize: "0.82rem", color: "var(--text-muted)", textDecoration: "line-through", fontFamily: "var(--font-mono)" }}>
              {formatToCurrency(totalGeneral)}
            </Typography>
          </Box>
        )}

        {descuento && descuentoAplicado > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <LocalOfferOutlinedIcon sx={{ fontSize: 14, color: "var(--success)" }} />
              <Typography sx={{ fontSize: "0.82rem", color: "var(--success)", fontWeight: 600, fontFamily: "var(--font-body)" }}>
                Descuento
              </Typography>
            </Box>
            <Typography sx={{ fontSize: "0.82rem", color: "var(--success)", fontWeight: 700, fontFamily: "var(--font-mono)" }}>
              − {formatToCurrency(descuentoAplicado)}
            </Typography>
          </Box>
        )}

        {/* Total */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", mt: 0.25 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "0.9rem", color: "var(--text-primary)", fontFamily: "var(--font-heading)" }}>
            Total
          </Typography>
          <Typography sx={{
            fontWeight: 800, fontSize: "1.4rem",
            color: "var(--accent)",
            fontFamily: "var(--font-heading)",
            lineHeight: 1,
          }}>
            {formatToCurrency(totalFinal)}
          </Typography>
        </Box>
      </Box>

      {/* ── Botón continuar ── */}
      <Button
        variant="contained"
        onClick={onNext}
        disabled={isDisabled}
        endIcon={<ArrowForwardIcon sx={{ fontSize: 18 }} />}
        fullWidth
        sx={{
          mt: 0.5,
          py: 1.25,
          borderRadius: "var(--radius-md)",
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.95rem",
          fontFamily: "var(--font-heading)",
          backgroundColor: "var(--accent)",
          boxShadow: isDisabled ? "none" : "var(--shadow-glow)",
          transition: "all var(--transition-base)",
          "&:hover:not(:disabled)": {
            backgroundColor: "var(--accent-hover)",
            boxShadow: "0 6px 20px rgba(233,69,96,0.4)",
            transform: "translateY(-1px)",
          },
          "&:disabled": {
            backgroundColor: "var(--bg-subtle)",
            color: "var(--text-muted)",
            boxShadow: "none",
          },
        }}
      >
        Continuar
      </Button>

    </Box>
  );
};

export default CartTotal;